import styles from "./style.module.scss";

export default function Notification({ html }) {
  return <div className={styles.Notif}>{html}</div>;
}
